"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var PageIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("g", { fill: "none", transform: "translate(4 5)" },
        React.createElement("g", { fill: "currentColor", fillRule: "nonzero", transform: "translate(4 5)" },
            React.createElement("rect", { width: "8", height: "1" }),
            React.createElement("rect", { width: "8", height: "1", y: "2" }),
            React.createElement("rect", { width: "8", height: "1", y: "4" })),
        React.createElement("rect", { width: "15", height: "13", x: ".5", y: ".5", stroke: "currentColor", rx: "1" }),
        React.createElement("rect", { width: "15", height: "1", x: "1", y: "1", fill: "currentColor", opacity: ".375" })))); };
exports.PageIcon = PageIcon;
